export default {
    all: [],

    get (username) {
        username = `${username}`.toLowerCase()
        return this.all.find((user) => {
            return `${user.username.toLowerCase()}` === `${username}`
        })
    },

    has (username) {
        return !!this.get(username)
    },

    upsert (user) {
        this.delete(user.username)
        this.all.push(user)
    },

    delete (username) {
        username = `${username}`.toLowerCase()
        this.all = this.all.filter((user) => {
            return `${user.username.toLowerCase()}` !== `${username}`
        })
    },
}
